<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>{{ data.sysText.editWorkday_header }}, {{ data.event.start | date }}</h6>
  <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
  <button
    type="button"
    class="button-reset info-button"
    [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
    [matTooltip]="data.sysText.addEditCalendarWorkday_info"
    [matTooltipShowDelay]="500"
    matTooltipPosition="before">
    <mat-icon class="button-icon">info_outline</mat-icon>
  </button>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <ng-container>
    <form [formGroup]="form">
      <div class="form-container">
        <div class="radio-stacked">
          <mat-radio-group [attr.aria-label]="data.sysText.workdayType_ariaLabel" [formControl]="form.controls.workdayOption" color="accent" (change)="onChange($event)">
            @for (option of workdayOptions; track option.id) {
              <mat-radio-button [value]="option.id">{{ option.description | capitalizefirst }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
        <div class="column-container">
          <app-input-field
            class="hours-input"
            [group]="form"
            [label]="data.sysText.addEditCalendarWorkday_workdayHours"
            [hideIconSpace]="true"
            [control]="form.controls.hours"
            [inputType]="'number'">
          </app-input-field>
          <div class="text-container">
            @for(item of defaultItems; track item) {
              <p class="body2"><i>{{ item }}</i></p>
            }
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

